import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
// eslint-disable-next-line jira/import/no-restricted-import, camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
import { formSubmitEntrypoint } from '@jira/spa-apps__software-form-submit/src/formSubmitEntrypoint.entrypoint.tsx';
import { chromelessLayout } from '@jira/platform__layouts-chromeless-layout/src/index.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { softwareFormSubmitRoute } from '@jira/router-routes__software-form-submit-routes/src/softwareFormSubmitRoute.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

const formSubmitPageEntrypoint = createPageEntryPoint({
	main: formSubmitEntrypoint,
});

export const softwareFormSubmitRouteEntry: Route = createEntry(softwareFormSubmitRoute, () => ({
	group: 'software',
	ufoName: 'next-gen-form-submit',
	layout: chromelessLayout,

	navigation: {
		menuId: MenuIdProjects,
	},

	resources: [
		...getNavigationResources(),
		// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
		// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
		// eslint-disable-next-line jira/router/no-project-context-resource
		projectContextResource,
		forgeProjectModuleResource,
		staticProjectSidebarNavigationResource,
		staticProjectSidebarConnectAddonsNavigationResource,
		// end of resources expanded from getNavigationSidebarProjectResource
		// eslint-disable-next-line camelcase
		DEPRECATED_DO_NOT_USE_projectDetailsResource,
	],

	entryPoint: () => formSubmitPageEntrypoint,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
